import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

// "YYYY-MM-DD" → end of that day in South African time.
const endOfDay = (iso) => (iso ? new Date(`${iso}T23:59:59+02:00`) : null);
const toLabel = (iso) => (iso ? iso.split("-").reverse().join("/") : "");

const timeLeft = (end, now) => {
  if (!end || Number.isNaN(end.getTime())) return null;
  const secs = Math.floor((end.getTime() - now) / 1000);
  if (secs <= 0) return null;
  return { d: Math.floor(secs / 86400), h: Math.floor((secs % 86400) / 3600), m: Math.floor((secs % 3600) / 60), s: secs % 60 };
};

export const pad = (n) => String(n).padStart(2, "0");

// Time left in the free launch period, or null when payments are on / no date / the date has passed.
export const useFreeCountdown = (tickMs = 60000) => {
  const { paymentsEnabled, freeUntil } = useAuth();
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), tickMs);
    return () => clearInterval(t);
  }, [tickMs]);
  const freeMode = paymentsEnabled === false;
  return { freeMode, label: toLabel(freeUntil), left: freeMode ? timeLeft(endOfDay(freeUntil), now) : null };
};

// Verified members rounded down to the nearest 10 ("120+"), or null when under 10.
export const useMemberCount = () => {
  const [count, setCount] = useState(null);
  useEffect(() => {
    api.get("/public-stats").then((r) => setCount(r.data.members)).catch(() => {});
  }, []);
  return count >= 10 ? `${Math.floor(count / 10) * 10}+` : null;
};
